import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div<{ $untouchable: boolean }>`
	opacity: ${(item) => (item.$untouchable ? 0.5 : 1)};
`;

export const addNewCard = styled.div`
	width: 100%;
	display: flex;
	gap: 0.5rem;
	align-items: center;
	cursor: pointer;

	p {
		color: ${color.interface.lightGray};
		font-size: 1.5rem;
		font-weight: 600;
	}
`;
